/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_Errors_Duplicate_Role_NameInputs */

const nl_auth_password_errors_duplicate_role_name = /** @type {(inputs: Auth_Password_Errors_Duplicate_Role_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze rolnaam bestaat al`)
};

/**

* @param {Auth_Password_Errors_Duplicate_Role_NameInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_password_errors_duplicate_role_name = /** @type {((inputs?: Auth_Password_Errors_Duplicate_Role_NameInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_Errors_Duplicate_Role_NameInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_password_errors_duplicate_role_name(inputs)
});
export { auth_password_errors_duplicate_role_name as "auth.password_errors.duplicate_role_name" }